import { useIntl } from 'react-intl'
import LineCheckIcon from 'LuxKit/Icons/line/LineCheckIcon'
import IconInCircle from 'tripPlanner/components/Icons/IconInCircle'
import { SuccessCard, SuccessHeader, SuccessTitle } from './shared'

function SuccessStep() {
  const intl = useIntl()

  return (
    <SuccessCard data-testid="embedded-account-access-success">
      <SuccessHeader>
        <IconInCircle icon={LineCheckIcon} circleColour="success" iconColour="neutral-eight" size={24} />
        <SuccessTitle variant="heading5" as="h3">{intl.formatMessage({
          id: 'BkhYjd9HtfEiOYomZQvV',
          defaultMessage: 'You’re logged in',
          description: 'Success title for embedded trip planner account access widget',
        })}
        </SuccessTitle>
      </SuccessHeader>
    </SuccessCard>
  )
}

export default SuccessStep
